import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { ensureNamespaces } from '../../i18n';

import {
  ContactsContent,
  ContactsDescription,
  ContactsFormCard,
  ContactsFormTitle,
  ContactsRow,
  ContactsSection,
  ContactsTitle,
  DeleteAccountCardParagraph,
  DeleteAccountInlineLink,
  DeleteAccountStep,
  DeleteAccountStepsList,
  LandingContainer,
} from './landingPage.styles';

const IN_APP_STEPS = ['step1', 'step2', 'step3'];
const DATA_ITEMS = ['item1', 'item2', 'item3', 'item4'];

export default function LandingDeleteAccountSection() {
  const { t } = useTranslation('landing');

  useEffect(() => {
    ensureNamespaces(['landing']);
  }, []);

  return (
    <ContactsSection id="delete-account">
      <LandingContainer>
        <ContactsRow>
          <ContactsContent>
            <ContactsTitle>{t('deleteAccount.title')}</ContactsTitle>
            <ContactsDescription>{t('deleteAccount.description')}</ContactsDescription>
          </ContactsContent>

          <ContactsFormCard>
            <ContactsFormTitle>{t('deleteAccount.howTitle')}</ContactsFormTitle>

            <ContactsFormTitle as="h4" style={{ fontSize: 18, marginTop: 4 }}>
              {t('deleteAccount.inAppTitle')}
            </ContactsFormTitle>
            <DeleteAccountStepsList>
              {IN_APP_STEPS.map((key) => (
                <DeleteAccountStep key={key}>{t(`deleteAccount.inAppSteps.${key}`)}</DeleteAccountStep>
              ))}
            </DeleteAccountStepsList>

            <ContactsFormTitle as="h4" style={{ fontSize: 18, marginTop: 8 }}>
              {t('deleteAccount.supportTitle')}
            </ContactsFormTitle>
            <DeleteAccountCardParagraph>
              {t('deleteAccount.supportText')}{' '}
              <DeleteAccountInlineLink as={Link} to="/support">
                {t('deleteAccount.supportLink')}
              </DeleteAccountInlineLink>
              .
            </DeleteAccountCardParagraph>

            <ContactsFormTitle as="h4" style={{ fontSize: 18, marginTop: 8 }}>
              {t('deleteAccount.dataTitle')}
            </ContactsFormTitle>
            <DeleteAccountStepsList data-variant="bullet">
              {DATA_ITEMS.map((key) => (
                <DeleteAccountStep key={key}>{t(`deleteAccount.dataItems.${key}`)}</DeleteAccountStep>
              ))}
            </DeleteAccountStepsList>

            <DeleteAccountCardParagraph>{t('deleteAccount.retention')}</DeleteAccountCardParagraph>
            <DeleteAccountCardParagraph>{t('deleteAccount.processing')}</DeleteAccountCardParagraph>
          </ContactsFormCard>
        </ContactsRow>
      </LandingContainer>
    </ContactsSection>
  );
}
